export const TYPING_TIMEOUTS = {
  // JT-92539: AWS Connect lacks reliable stop-typing events for agents
  agent: 5000,
} as const;
